import { FC } from "react";
import {
  Box,
  Button,
  Dialog,
  Typography,
  useMediaQuery,
  Link,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import Uniswap from "../../assets/images/UniSwapIcon.svg";
import PancakeSwap from "../../assets/images/PanCakeSwapIcon.svg";
import Mexc from "../../assets/images/mexc_logo.svg";
import Ondefy from "../../assets/images/xdc-logo.png";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";
import cross from "../../assets/images/cross.svg";
import useStyles from "../Styles/ProjectModalStyles";
import { BuyGainsModalProps } from "../../interfaces";
import { useAccount } from "wagmi";

const BuyGainModel: FC<BuyGainsModalProps> = ({ open, setOpen }) => {
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));

  const { address } = useAccount();
  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Box component="section">
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={` ${classes.modalpages} ${classes.buymodal}`}
        >
          <Box
            ml={isActive ? "1.2rem" : "2rem"}
            my={isActive ? "1.2rem" : "2rem"}
            mr={isActive ? "1.2rem" : "2rem"}
          >
            <Box className="relative-box">
              {
                <img
                  src={cross}
                  alt=""
                  className="cross-icon"
                  style={{
                    top: "0",
                    right: ".5rem",
                  }}
                  onClick={handleClose}
                />
              }
              <ProjectPoolHeading title1="Buy " title2="GAINS" />

              <Box
                className="border-box"
                mr={isActive ? 0 : 2}
                py={2}
                pl={2}
                pr={1}
                mt={isActive ? 2 : 3}
              >
                <Typography
                  variant="subtitle1"
                  color="secondary"
                  className="fw-normal t-color "
                >
                  {" "}
                  Your wallet{" "}
                  <Typography
                    variant="subtitle1"
                    component="span"
                    className="fw-bold text-resposive-320"
                  >
                    {address}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    component="span"
                    className="fw-normal"
                  >
                    {" "}
                    does not contain{" "}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    component="span"
                    color="primary"
                    className="fw-bold"
                  >
                    GAINS
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    component="span"
                    className="fw-normal"
                  >
                    . Buy at least 250 GAINS and try again.
                  </Typography>
                </Typography>
              </Box>
              <Box
                mt={isActive ? 3 : 5}
                mb={3}
                textAlign="center"
                mr={isActive ? 0 : 4}
              >
                <Link
                  href="https://app.uniswap.org/swap?outputCurrency=0x056C1D42Fb1326f57da7f19eBB7dDA4673f1FF55"
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none"
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    className=" button-res"
                    startIcon={<img src={Uniswap} alt="gains" />}
                  >
                    buy on uniswap now
                  </Button>
                </Link>
              </Box>
              <Box my={isActive ? "12px" : ""}>
                {" "}
                {/**main box item */}
                <Box ml={1} mr={isActive ? 0 : 4}>
                  <Typography
                    variant="subtitle1"
                    color="primary"
                    className="smalltext-color suodo-text"
                    align="center"
                  >
                    OR
                  </Typography>
                </Box>
              </Box>
              <Box
                mt={isActive ? 3 : 3}
                textAlign="center"
                mr={isActive ? 0 : 4}
                mb={3}
              >
                <Link
                  href="https://pancakeswap.finance/swap?outputCurrency=0xf1C3e69494E27bf067C4076a6f244a46446719d6"
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none"
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    className="button-res "
                    startIcon={<img src={PancakeSwap} alt="gains" />}
                  >
                    Buy On Pancakeswap Now
                  </Button>
                </Link>
              </Box>
              <Box my={isActive ? "12px" : ""}>
                {" "}
                {/**main box item */}
                <Box ml={1} mr={isActive ? 0 : 4}>
                  <Typography
                    variant="subtitle1"
                    color="primary"
                    className="smalltext-color suodo-text"
                    align="center"
                  >
                    OR
                  </Typography>
                </Box>
              </Box>
              <Box
                mt={isActive ? 3 : 3}
                textAlign="center"
                mr={isActive ? 0 : 4}
                mb={3}
              >
                <Link
                  href="https://www.mexc.com/exchange/GAINS_USDT?_from=market"
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none"
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    className="button-res "
                    startIcon={<img src={Mexc} alt="buy gains on mexc" />}
                  >
                    Buy On MEXC
                  </Button>
                </Link>
              </Box>
              <Box my={isActive ? "12px" : ""}>
                {" "}
                {/**main box item */}
                <Box ml={1} mr={isActive ? 0 : 4}>
                  <Typography
                    variant="subtitle1"
                    color="primary"
                    className="smalltext-color suodo-text"
                    align="center"
                  >
                    OR
                  </Typography>
                </Box>
              </Box>
              <Box
                mt={isActive ? 3 : 3}
                textAlign="center"
                mr={isActive ? 0 : 4}
              >
                <Link
                  href="https://ramp.ondefy.com/?tokenId=gains"
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none"
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    className="button-res "
                    startIcon={<img width="28px" src={Ondefy} alt="gains" />}
                  >
                    {"Buy on XDC"}
                  </Button>
                </Link>
              </Box>
              <Box
                mt={isActive ? 3 : 3}
                textAlign="center"
                style={{ paddingRight: "20px" }}
              >
                <Link
                  href="http://gainsassociates.medium.com/how-to-bridge-gains-from-ethereum-to-bnb-chain-with-chainport-340e8f0e40a"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Typography
                    style={{ fontWeight: 700 }}
                    color="primary"
                    align="center"
                  >
                    {"Token Bridge B2B <> ETH"}
                  </Typography>
                </Link>
              </Box>
              <Box
                mt={isActive ? 3 : 3}
                textAlign="center"
                style={{ paddingRight: "20px" }}
              >
                <Link
                  href="https://stargate.finance/?srcChain=xdc&srcToken=0xd9b312D77Bc7BEd9B9CecB56636300bED4Fe5Ce9&dstChain=ethereum&dstToken=0x056C1D42Fb1326f57da7f19eBB7dDA4673f1FF55"
                  rel="noreferrer"
                >
                  <Typography
                    style={{ fontWeight: 700 }}
                    color="primary"
                    align="center"
                  >
                    {"Token Bridge ETH <> XDC"}
                  </Typography>
                </Link>
              </Box>
            </Box>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default BuyGainModel;
